import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/outreach-templates')({
    component: OutreachTemplatesRedirect,
});

// Outreach templates now live at the bottom of the Scheduling page.
function OutreachTemplatesRedirect() {
    return <Navigate to="/settings/outreach-automation" replace={true} />;
}
